module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.optionsReady && _vm.showNewsletterModal) ? _c('div', {
    staticClass: "newsletter-modal-mask",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal('close')
      }
    }
  }, [_c('div', {
    staticClass: "newsletter-modal-wrapper-close",
    on: {
      "click": function($event) {
        return _vm.closeModal('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "newsletter-modal-wrapper"
  }, [_c('div', {
    staticClass: "newsletter-modal-container"
  }, [_c('div', {
    staticClass: "newsletter-modal-close"
  }, [_c('button', {
    staticClass: "newsletter-modal-default-button",
    on: {
      "click": function($event) {
        return _vm.closeModal('close')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "newsletter-modal-content"
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.options.newsletter_modal_title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rulemailer-subscriber-form"
  }, [_c('form', {
    ref: "newsletterSignup",
    attrs: {
      "id": "rule-optin-form",
      "action": "https://app.rule.io/subscriber-form/subscriber",
      "target": "_blank",
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleNewsletterSignup.apply(null, arguments)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "36555",
      "name": "tags[]"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "9c98708c-d50b816-1e87530-b14380d-80c34b8-019"
    }
  }), _vm._v(" "), _c('label', [_vm._v("E-post")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "placeholder": "E-post",
      "name": "rule_email",
      "required": "required"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Namn")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Namn",
      "name": "fields[Person.Fornamn]"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Organisation/företag")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Organisation/företag",
      "name": "fields[Person.Organisation]"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "rulemailer-email-check"
  }, [_vm._v("Are you machine?")]), _vm._v(" "), _c('input', {
    staticClass: "rulemailer-email-check",
    attrs: {
      "type": "checkbox",
      "name": "email_field",
      "value": "1",
      "tabindex": "-1",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "language",
      "value": "sv"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Skicka")])])]), _vm._v(" "), _c('div', {
    staticClass: "newsletter-field"
  }, [_c('a', {
    domProps: {
      "textContent": _vm._s(_vm.options.newsletter_modal_close_message)
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('forever')
      }
    }
  })])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "confirmation",
      "required": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Jag godkänner personuppgiftshantering. ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://primegroup.com/article/gdpr-policy/",
      "target": "_blank"
    }
  }, [_vm._v("GDPR Policy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aed1d5bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterModal.vue
// module id = 360
// module chunks = 0